// Copyright (C) 2019 TANNER AG

import React, { useEffect } from "react";
import * as PropTypes from "prop-types";
import { Mutation } from "react-apollo";
import { withStore } from "../store/withstore";
import { tcoCompareMutation, lccCompareMutation } from "../queries/compare";
import { Spinner } from "../components/spinner";
import { Error } from "../components/error";

const formatParams = (params, type) => ({
	fuel: params.bus.fuel,
	vehicleType: params.bus.type,
	drivingProfile: params.drivingProfile,
	efficientHybrid: (params.efficientHybrid === null) ? false : params.efficientHybrid,
	fuelPrice: params.fuelPrice,
	holdingPeriod: params.holdingPeriod,
	annualMileage: params.annualMileage,
	...(type === "TCO") && {
		purchasePrice: params.purchasePrice,
		residualValue: params.residualValue
	}
});

const Compare = (props) => {
	useEffect(() => {
		if (props.called) {
			return;
		}
		props.compare();
	}, [props.called]);

	if (props.loading || !props.called) {
		return <Spinner label="TCO wird berechnet..."/>;
	}

	if (props.error) {
		return <Error message={props.error}/>;
	}

	return props.children(props.data[Object.keys(props.data)[0]]);
};

const CompareWrapper = (props) => {
	const { store: { a, b, configuration } } = props;
	const mutation = (configuration === "TCO") ? tcoCompareMutation : lccCompareMutation;

	return (
		<Mutation
			mutation={mutation}
			variables={{ busAParams: formatParams(a, configuration), busBParams: formatParams(b, configuration) }}
		>
			{(compare, options) => (
				<Compare compare={compare} {...options} configuration={configuration}>
					{(data) => props.children(data)}
				</Compare>
			)}
		</Mutation>
	);
};

CompareWrapper.propTypes = {
	store: PropTypes.object
};

export default withStore(CompareWrapper);



// WEBPACK FOOTER //
// ./src/tco/result/compare.js